import { constants } from '../../config/constants';
import { appendScriptsToHead, createScriptTag } from '../../utils/DOMUtil';

export const loadFitAnalyticsScript = () => {
  const dynamicScript = createScriptTag({
    src: constants.FIT_ANALYTICS,
    async: true,
  });
  appendScriptsToHead(dynamicScript);
};
